import React from "react";
import ConnectionItem from "./ConnectionItem";
import { useIntl } from "react-intl";
import { StyledAppScrollbar } from "../../index.styled";
import AppList from "@lib/components/AppComponents/AppList";
import ChatListSkeleton from "@lib/components/AppComponents/AppSkeleton/ChatListSkeleton";
import ListEmptyResult from "@lib/components/AppComponents/AppList/ListEmptyResult";
import { useQuery } from "@tanstack/react-query";
import { getTelegramBotUsers } from "@lib/api/telegramBotConfigs";
import { ITelegramBotUser } from "@lib/types/TelegramChatBot";

const ConnectionList: React.FC = () => {
  const { messages } = useIntl();

  const { data, isLoading, isPending } = useQuery({
    queryKey: ["connectionList"],
    queryFn: () => getTelegramBotUsers({}),
  });
  const connectionList = data?.data?.data;

  return (
    <StyledAppScrollbar>
      <AppList
        data={connectionList || []}
        ListEmptyComponent={
          <ListEmptyResult
            content={messages["chatApp.noUserFound"] as string}
            loading={isLoading || isPending}
            placeholder={<ChatListSkeleton />}
          />
        }
        renderItem={(item: ITelegramBotUser) => (
          <ConnectionItem key={item.id} item={item} />
        )}
      />
    </StyledAppScrollbar>
  );
};

export default ConnectionList;
